var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.589844,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#003588"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_4639)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_80_4639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9375 30.5898C30.9375 31.1076 30.5178 31.5273 30 31.5273C29.4822 31.5273 29.0625 31.1076 29.0625 30.5898C29.0625 30.0721 29.4822 29.6523 30 29.6523C30.5178 29.6523 30.9375 30.0721 30.9375 30.5898Z",
    fill: "#FAFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9375 30.5898C30.9375 31.1076 30.5178 31.5273 30 31.5273C29.4822 31.5273 29.0625 31.1076 29.0625 30.5898C29.0625 30.0721 29.4822 29.6523 30 29.6523M30.9375 30.5898C30.9375 30.0721 30.5178 29.6523 30 29.6523M30.9375 30.5898H35.625M30 29.6523V23.7148M41.25 30.5898C41.25 36.8031 36.2133 41.8398 30 41.8398C23.7868 41.8398 18.75 36.8031 18.75 30.5898C18.75 24.3766 23.7868 19.3398 30 19.3398C36.2133 19.3398 41.25 24.3766 41.25 30.5898Z",
    stroke: "#FAFCFF",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_4639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(15 15.5898)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_80_4639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(15 15.5898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.a5fade2aa4cffc70a0556cf94fd50c9a.svg";
export { ForwardRef as ReactComponent };